import http from 'hub-http/clients/apiClient';
export const getRevisionRollupsByFlowId = (flowId, pageId, limit, auditEventHistoryFilters) => {
  const filters = auditEventHistoryFilters && auditEventHistoryFilters.getFiltersForApi();
  return http.post('automationmanagement/v1/revision/rollup', {
    data: {
      flowId,
      after: pageId,
      limit,
      endTimestamp: filters && filters.timestamp,
      startTimestamp: filters && filters.cutoffTime,
      userId: filters && filters.userId
    }
  });
};